import request from '../utils/request'

// 针对本次，app 外的使用 report_event_without_login，其他的依旧使用 report_event
const isApp = /bcz_app_([a-zA-Z]+)(_[a-zA-Z]+)?\/(\d*\.?\d*)/.test(
  navigator.userAgent
)

const url = 'https://events.baicizhan.com/api/system/report_event'

let prefix = ''
if (process.env.NODE_ENV === 'production') {
  prefix = '//vocabulary_beta.baicizhan.com'
}

let prefix2 = ''
if (process.env.NODE_ENV !== 'production') {
  prefix2 = '/api'
}

/**
 * 上报数据接口
 * @param {Object}} options 事件数据对象
 * {
 *  product_id: 'bcz_app_h5',
 *  stat_group: 事件所属组
 *  event_id: 事件的名称
 * }
 */
export function reportEvent(options) {
  return request(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'text/plain'
    },
    body: [
      {
        log_time: new Date().getTime(),
        product_id: 'bcz_app_h5',
        ...options
      }
    ]
  })
}

/**
 * 创建测试接口
 */
export function fetchCreate(options) {
  return request(prefix + '/vocabulary/create', {
    method: 'POST',
    body: options
  })
}

/**
 * 完成一道题之后上传成绩并获取下一个单词的信息的接口
 */
export function fetchNext(options) {
  return request(prefix + '/vocabulary/next', {
    method: 'POST',
    body: options
  })
}

/**
 * 获取用户广告
 * @param {number}} type 1: 阅读， 2: 听力
 * @param {number} number 分数
 */
export function fetchResultAd(type, number) {
  return request(
    `//advertise.baicizhan.com/api/advertise/vocabulary/getResultAd?type=${type}&number=${number}`
  )
}

/**
 * 上传结果
 * @param {object}} options
 */
export function uploadResult(options) {
  const { testType } = options
  let requestUrl =
    prefix2 +
    '/vocabulary/' +
    (testType === 2
      ? 'save_listening_vocabulary_count'
      : 'save_vocabulary_count')
  return request(requestUrl, {
    method: 'POST',
    body: {
      count: options.score,
      steps: options.count
    }
  })
}
